// 金額計算ヘルパ — 円(INTEGER)前提。固定ロジックを案件画面に散らさずここへ集約。

export function calcNet(contract: number | null, subsidy: number | null): number {
  // 実質負担額 = 契約金額 - 補助金金額
  return Math.max(0, (contract ?? 0) - (subsidy ?? 0));
}

export function calcGross(
  contract: number | null,
  commission: number | null,
  feesTotal: number | null,
): number {
  // 粗利見込み = 契約金額 - 紹介料 - 費目合計（TUSG管理費・開発保守費 等のカスタム費目）
  return (contract ?? 0) - (commission ?? 0) - (feesTotal ?? 0);
}

export function formatJPY(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return "¥" + amount.toLocaleString("ja-JP");
}

export function parseAmount(input: string): number | null {
  if (input == null || input.trim() === "") return null;
  const n = Number(input.replace(/[, ¥]/g, ""));
  if (!Number.isFinite(n)) return null;
  return Math.round(n);
}
